import React, { Component } from 'react';
import { Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import Breadcrumb from './breadcrumb';
import { individualTestStatuses } from '../../../services/common/optionsData';
import DateRangeFilter from '../../common/DateRangeFilter';

class SearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        return (
            <div>
                <Breadcrumb
                    onBtnExportZipForRequisitions={() => {
                        this.props.onBtnExportZipForRequisitions();
                    }}
                    onBtnExport={() => {
                        this.props.onBtnExport();
                    }}
                    onIsArchivedInformation={(event) => {
                        this.props.onIsArchivedInformation(event);
                    }}
                    isArchived={this.props.isArchived}
                />
                <div className="row mt-4 px-3">
                    <div className="col-md-9 col-12" style={{ borderRight: '2px solid lightGray' }}>
                        <div className="row">
                            <div className="col-md-6 col-12 mb-3">
                                <FormControl className="filter-select-bar" variant="outlined">
                                    <InputLabel id="facility-label">Select Facility</InputLabel>
                                    {this.props.facilities && this.props.facilities.length <= 1 && (
                                        <Select
                                            labelId="facility-label"
                                            id="facility-select"
                                            value={
                                                this.props.facilityId && this.props.facilityId.length
                                                    ? this.props.facilityId
                                                    : ''
                                            }
                                            onChange={this.props.handleFiltersChange}
                                            label="Select Facility"
                                            name="facility_id"
                                        >
                                            {this.props.facilities.map((fac) => {
                                                return (
                                                    <MenuItem key={fac._id} value={fac._id}>
                                                        <span className="mr-2">{fac.name}</span>
                                                        {fac.archived === 'archived' && <b>{' ( Archived )'}</b>}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    )}
                                    {this.props.facilities && this.props.facilities.length > 1 && (
                                        <Select
                                            labelId="facility-label"
                                            id="facility-select"
                                            value={this.props.facilityId}
                                            onChange={this.props.handleFiltersChange}
                                            label="Select Facility"
                                            name="facility_id"
                                            multiple
                                            renderValue={(selected) => {
                                                if (selected.length === this.props.facilities.length) {
                                                    return 'All Facilities';
                                                } else {
                                                    let displayStrings = [];
                                                    this.props.facilities.map((fac) => {
                                                        if (selected.includes(fac._id)) {
                                                            displayStrings.push(fac.name);
                                                        }
                                                        return null;
                                                    });
                                                    return displayStrings.join(', ');
                                                }
                                            }}
                                        >
                                            <MenuItem
                                                className={
                                                    this.props.facilityId &&
                                                    this.props.facilityId.length === this.props.facilities.length
                                                        ? 'Mui-selected'
                                                        : ''
                                                }
                                                value="all"
                                                key="all"
                                            >
                                                <Checkbox
                                                    checked={
                                                        this.props.facilityId &&
                                                        this.props.facilityId.length === this.props.facilities.length
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                All Facilities
                                            </MenuItem>
                                            {this.props.facilities.map((fac) => {
                                                return (
                                                    <MenuItem key={fac._id} value={fac._id}>
                                                        <Checkbox
                                                            checked={
                                                                this.props.facilityId &&
                                                                this.props.facilityId.includes(fac._id)
                                                                    ? true
                                                                    : false
                                                            }
                                                            className={fac.type === 'facility' ? 'ml-5' : ''}
                                                        />
                                                        <span className="mr-2">{fac.name}</span>
                                                        {fac.archived === 'archived' && <b>{' ( Archived )'}</b>}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    )}
                                </FormControl>
                                <div className="row">
                                    <div className="col-md-6">
                                        <FormControl className="filter-select-bar" variant="outlined">
                                            <InputLabel id="test-label">Select Test</InputLabel>
                                            {this.props.tests && this.props.tests.length <= 1 && (
                                                <Select
                                                    labelId="test-label"
                                                    id="test-select"
                                                    label="Select Test"
                                                    value={
                                                        this.props.testIds && this.props.testIds.length
                                                            ? this.props.testIds
                                                            : ''
                                                    }
                                                    onChange={this.props.handleFiltersChange}
                                                    name="testIds"
                                                >
                                                    {this.props.tests.map((test) => {
                                                        return (
                                                            <MenuItem key={test._id} value={test._id}>
                                                                {test.name}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            )}
                                            {this.props.tests && this.props.tests.length > 1 && (
                                                <Select
                                                    labelId="test-label"
                                                    id="test-select"
                                                    value={this.props.testIds}
                                                    onChange={this.props.handleFiltersChange}
                                                    label="Select Test"
                                                    name="testIds"
                                                    multiple
                                                    renderValue={(selected) => {
                                                        if (selected.length === this.props.tests.length) {
                                                            return 'All Tests';
                                                        } else {
                                                            let displayStrings = [];
                                                            this.props.tests.map((test) => {
                                                                if (selected.includes(test._id)) {
                                                                    displayStrings.push(test.name);
                                                                }
                                                                return null;
                                                            });
                                                            return displayStrings.join(', ');
                                                        }
                                                    }}
                                                >
                                                    <MenuItem
                                                        className={
                                                            this.props.testIds &&
                                                            this.props.testIds.length === this.props.tests.length
                                                                ? 'Mui-selected'
                                                                : ''
                                                        }
                                                        key="all"
                                                        value="all"
                                                    >
                                                        <Checkbox
                                                            checked={
                                                                this.props.testIds &&
                                                                this.props.testIds.length === this.props.tests.length
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        All Tests
                                                    </MenuItem>
                                                    {this.props.tests.map((test) => {
                                                        return (
                                                            <MenuItem key={test._id} value={test._id}>
                                                                <Checkbox
                                                                    checked={
                                                                        this.props.testIds &&
                                                                        this.props.testIds.includes(test._id)
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                {test.name}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            )}
                                        </FormControl>
                                    </div>
                                    <div className="col-md-6">
                                        <FormControl className="filter-select-bar" variant="outlined">
                                            <InputLabel>Select Status</InputLabel>
                                            <Select
                                                value={this.props.selectedStatuses}
                                                onChange={this.props.handleFiltersChange}
                                                label="Select Status"
                                                name="selectedStatuses"
                                                multiple
                                                renderValue={(selected) => {
                                                    if (selected.length === individualTestStatuses.length) {
                                                        return 'All';
                                                    } else {
                                                        return this.props.selectedStatuses.join(', ');
                                                    }
                                                }}
                                            >
                                                <MenuItem
                                                    className={
                                                        this.props.selectedStatuses &&
                                                        this.props.selectedStatuses.length ===
                                                            individualTestStatuses.length
                                                            ? 'Mui-selected'
                                                            : ''
                                                    }
                                                    key="all"
                                                    value="all"
                                                >
                                                    <Checkbox
                                                        checked={
                                                            this.props.selectedStatuses &&
                                                            this.props.selectedStatuses.length ===
                                                                individualTestStatuses.length
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    All
                                                </MenuItem>
                                                {individualTestStatuses.map((statusItem) => {
                                                    return (
                                                        <MenuItem key={statusItem} value={statusItem}>
                                                            <Checkbox
                                                                checked={
                                                                    this.props.selectedStatuses &&
                                                                    this.props.selectedStatuses.includes(statusItem)
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            {statusItem}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 mb-3" style={{ marginTop: '-10px' }}>
                                <div className="row">
                                    <div className="col-12">
                                        <DateRangeFilter
                                            date_range={this.props.date_range}
                                            from_date={this.props.from_date}
                                            to_date={this.props.to_date}
                                            updateDateRange={this.props.updateDateRange}
                                            handleDateFiltersChange={this.props.handleDateFiltersChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 col-12 grid-buttons">
                        <div className="text-center">
                            <TextField
                                label="Current Grid Search"
                                className="filter-search-bar mt-2"
                                id="reset-form"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                margin="none"
                                size="small"
                                onChange={this.props.onFilterTextChange}
                            />
                            <div>
                                <TextField
                                    sx={{ width: '100px' }}
                                    label="Page Size"
                                    className="mt-3"
                                    id="page-size"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    type="number"
                                    margin="none"
                                    size="small"
                                    onChange={this.props.onPageSizeChanged}
                                />
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.saveState()}
                                >
                                    <i className="far fa-save"></i> Save
                                </button>
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.resetState()}
                                >
                                    {' '}
                                    <i className="fa fa-repeat"></i> Default
                                </button>
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.clearFilter()}
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filters
                                </button>
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.showBulkStatus()}
                                >
                                    <i className="fas fa-tasks" aria-hidden="true"></i> Update Bulk Status
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchMenu;
